<template>
    <div id="cart-items">
        <div class="form-group">
            <label for="search" class="control-label">Filter produkter:</label>
            <input type="text" class="form-control" name="search" id="search" v-model="search">
        </div>
        <table>
            <thead>
                <th>Navn</th>
                <th></th>
            </thead>

            <tbody>
                <tr v-for="item in filteredItems" :key="item.id">
                    <td v-text="item.name"></td>
                    <td class="text-right">
                        <button class="btn btn-sm btn-success float-right text-white" :id="'btn_add_'+item.id"
                        @click.prevent="addToCart(item)"> <i class="fa fa-fw fa-plus"></i> </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: ['items'],
    data() {
        return {
            search: '',
        }
    },
    methods: {
        addToCart(item) {
            console.log('addToCart() template.' );
            // console.log(item );
            this.$store.commit('addToCart', item);
        }
    },
    computed: {
        filteredItems() {
            return this.items.filter(item => {
                return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
            })
        }
    }

}
</script>
